import { render, staticRenderFns } from "./remainingBudget.vue?vue&type=template&id=b38d54ea&scoped=true&"
import script from "./remainingBudget.vue?vue&type=script&lang=js&"
export * from "./remainingBudget.vue?vue&type=script&lang=js&"
import style0 from "./remainingBudget.vue?vue&type=style&index=0&id=b38d54ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38d54ea",
  null
  
)

export default component.exports